import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {Auth} from '../auth/auth.service';
import {Role} from '../auth/role';

@Component({
    selector: 'kkk-main-menu',
    templateUrl: './main-menu.component.html'
})
export class MainMenuComponent implements OnInit, OnDestroy {
    public expanded = false;
    public mainMenu: IMainMenu;

    private tokenSubscription: Subscription;

    get ariaExpanded() {
        return this.expanded ? 'true' : 'false';
    }

    constructor(public auth: Auth, private _router: Router) {
    }

    ngOnDestroy() {
        this.tokenSubscription && this.tokenSubscription.unsubscribe();
    }

    ngOnInit() {
        this.initMainMenu();
        this.tokenSubscription = this.auth.tokenChange.subscribe(
            this.initMainMenu.bind(this)
        );
    }

    doAction(item: IMenuItem, event: Event): void {
        if (item.action && typeof item.action === 'function') {
            item.action(item, event);
        } else {
            this.collapse();
        }
    }

    collapse() {
        this.expanded = false;
        this.mainMenu.openedSubmenu = null;
        this.mainMenu.openedSubSubmenu = null;
    }

    logout() {
        this.auth.logOut();
        this.collapse();
        this._router.onSameUrlNavigation = 'reload';
        return this._router.navigate([this._router.url]);
    }

    showSubmenu(menuItem: IMenuItem): void {
        if (this.mainMenu.openedSubmenu === menuItem.submenu) {
            this.mainMenu.openedSubmenu = null;
            this.mainMenu.openedSubSubmenu = null;
        } else {
            this.mainMenu.openedSubmenu = menuItem.submenu;
        }
    }

    showSubSubmenu(menuItem: IMenuItem): void {
        if (this.mainMenu.openedSubSubmenu === menuItem.submenu) {
            this.mainMenu.openedSubSubmenu = null;
        } else {
            this.mainMenu.openedSubSubmenu = menuItem.submenu;
        }
    }

    private initMainMenu() {
        this.mainMenu = {
            menus: [
                {
                    cssClass: 'mr-auto',
                    items: [
                        {
                            id: 'main-menu-who-we-are',
                            // routerLink: ['/kik-vagyunk'],
                            action: this.showSubmenu.bind(this),
                            label: 'Kik vagyunk?',
                            submenu: {
                                items: [
                                    {routerLink: ['/rolunk'], label: 'Rólunk'},
                                    {routerLink: ['/kapcsolat'], label: 'Kapcsolat'},
                                    {routerLink: ['/komment'], label: 'Üzenj nekünk!'},
                                ]
                            }
                        },
                        {
                            id: 'main-menu-what-we-do',
                            // routerLink: ['/mit-teszunk'],
                            action: this.showSubmenu.bind(this),
                            label: 'Mit teszünk?',
                            submenu: {
                                items: [
                                    {
                                        id: 'main-menu-programs',
                                        // routerLink: ['/programok'],
                                        action: this.showSubSubmenu.bind(this),
                                        label: 'Programok',
                                        submenu: {
                                            items: [
                                                {routerLink: ['/programok/istentiszteletek'], label: 'Istentiszteletek'},
                                                {routerLink: ['/programok/gyerekfogi'], label: 'Gyermek foglalkozások'},
                                                {routerLink: ['/programok/ifi'], label: 'Ifjúsági alkalmak'},
                                                {routerLink: ['/programok/hazasrandi'], label: 'Házasoknak'},
                                                {routerLink: ['/programok/hazicsoportok'], label: 'Házicsoportok'},
                                                {routerLink: ['/programok/taborok'], label: 'Táborok, konferenciák'},
                                            ]
                                        }
                                    },
                                    {
                                        id: 'main-menu-missions',
                                        // routerLink: ['/missziok'],
                                        action: this.showSubSubmenu.bind(this),
                                        label: 'Missziók',
                                        submenu: {
                                            items: [
                                                {routerLink: ['/missziok/bab'], label: 'Báb csapat'},
                                                {routerLink: ['/missziok/pantomim'], label: 'Pantomim'},
                                                {routerLink: ['/missziok/plantalt'], label: 'Plántált gyülekezeteink'},
                                                {routerLink: ['/missziok/misszionariusok'], label: 'Misszionáriusaink'},
                                            ]
                                        }
                                    },
                                    {routerLink: ['/bibliaiskola'], label: 'Bibliaiskola'},
                                ]
                            }
                        },
                        {
                            id: 'main-menu-records',
                            // routerLink: ['/felvetelek'],
                            action: this.showSubmenu.bind(this),
                            label: 'Felvételek',
                            submenu: {
                                items: [
                                    {
                                        routerLink: ['/felvetelek/tanitasok'],
                                        label: 'Tanítások',
                                        icon: 'fa-microphone'
                                    },
                                    {
                                        routerLink: ['/felvetelek/sorozatok'],
                                        label: 'Sorozatok',
                                        icon: 'fa-files-o'
                                    },
                                ]
                            }
                        },
                        {
                            id: 'main-menu-events',
                            // routerLink: ['/tartalmak'],
                            action: this.showSubmenu.bind(this),
                            label: 'Tartalmak',
                            submenu: {
                                items: [
                                    {
                                        routerLink: ['/tartalmak/hirek'],
                                        label: 'Hírek',
                                        icon: 'fa-newspaper-o'
                                    },
                                    // {
                                    //     routerLink: ['/tartalmak/naptar'],
                                    //     label: 'Naptár',
                                    //     icon: 'fa-calendar'
                                    // },
                                ]
                            }
                        },
                        {
                            routerLink: ['/barataink'],
                            label: 'Barátaink'
                        },
                    ]
                },
                {
                    cssClass: 'ml-auto',
                    items: this.getLoggedInMenu()
                },
                this.getUserMenu()
            ]
        };
    }

    private getLoggedInMenu(): IMenuItem[] {
        const loggedInMenu = [this.getWorshipMenu()];
        if (this.auth.hasAnyRoleOf(Role.ADMIN, Role.EMAIL_SENDER, Role.PUBLISHER, Role.AUDIO_VIDEO, Role.MODERATOR)) {
            loggedInMenu.push(this.getAdministrationMenu());
        }
        return loggedInMenu;
    }

    private getWorshipMenu(): IMenuItem {
        const worshipMenu: IMenuItem = {
            id: 'main-menu-worship',
            // routerLink: ['/dicsi/kottak'],
            action: this.showSubmenu.bind(this),
            label: 'Dicsicsapat',
            icon: 'fa-music',
            submenu: {
                cssClass: 'align-right',
                items: [
                    {routerLink: ['/dicsi/kottak'], label: 'Kották', icon: 'fa-file-text-o'},
                ]
            }
        };
        if (this.auth.hasRole(Role.WORSHIP_LEADER)) {
            worshipMenu.submenu.items.push({
                routerLink: ['/dicsi/kottak/uj'],
                label: 'Új kotta',
                icon: 'fa-plus'
            });
            worshipMenu.submenu.items.push({
                routerLink: ['/dicsi/csapat'],
                label: 'Csapat',
                icon: 'fa-users'
            });
        }
        if (this.auth.hasAnyRoleOf(Role.WORSHIP_LEADER, Role.WORSHIPER, Role.AUDIO_VIDEO)) {
            worshipMenu.submenu.items.push({
                routerLink: ['/dicsi/beosztas'],
                label: 'Beosztás',
                icon: 'fa-calendar'
            });
        }
        return worshipMenu;
    }

    private getAdministrationMenu(): IMenuItem {
        const adminMenu: IMenuItem = {
            id: 'main-menu-admin',
            // routerLink: ['/admin'],
            action: this.showSubmenu.bind(this),
            label: 'Adminisztráció',
            submenu: {
                cssClass: 'align-right',
                items: [
                ]
            }
        };
        if (this.auth.hasAnyRoleOf(Role.ADMIN, Role.CAMPER)) {
            adminMenu.submenu.items.push({
                routerLink: ['/taborozo/admin'],
                label: 'Táborok',
                icon: 'fa-home'
            });
        }
        if (this.auth.hasRole(Role.PUBLISHER)) {
            adminMenu.submenu.items.push({
                routerLink: ['/admin/tartalmak'],
                label: 'Tartalmak',
                icon: 'fa-newspaper-o'
            });
        }
        if (this.auth.hasRole(Role.AUDIO_VIDEO)) {
            adminMenu.submenu.items.push({
                routerLink: ['/admin/felvetelek'],
                label: 'Felvételek',
                icon: 'fa-microphone'
            });
        }
        if (this.auth.hasRole(Role.EMAIL_SENDER)) {
            adminMenu.submenu.items.push({
                routerLink: ['/email'],
                label: 'Email küldés',
                icon: 'fa-paper-plane-o'
            });
        }
        if (this.auth.hasAnyRoleOf(Role.MODERATOR)) {
            adminMenu.submenu.items.push({
                routerLink: ['/admin/kommentek'],
                label: 'Moderálás',
                icon: 'fa-comment-o'
            });
        }
        if (this.auth.hasRole(Role.ADMIN)) {
            adminMenu.submenu.items.push({
                routerLink: ['/admin/felhasznalok'],
                label: 'Felhasználók',
                icon: 'fa-users'
            });
        }
        return adminMenu;
    }

    private getUserMenu(): IMenu {
        if (this.auth.isLoggedIn()) {
            return {
                items: [
                    {
                        id: 'main-menu-user-menu',
                        // routerLink: ['/felhasznalo/profil'],
                        action: this.showSubmenu.bind(this),
                        label: this.auth.user.nickname || this.auth.user.firstname || this.auth.user.lastname || this.auth.user.email,
                        submenu: {
                            cssClass: 'align-right',
                            items: [
                                {
                                    routerLink: ['/felhasznalo/profil'],
                                    label: 'Profil',
                                    icon: 'fa-user'
                                },
                                {
                                    action: this.logout.bind(this),
                                    label: 'Kilépés',
                                    icon: 'fa-sign-out'
                                }
                            ]
                        }
                    }
                ]
            };
        }
        return {
            cssClass: 'ml-auto mt-3 mt-lg-0',
            items: [
                {
                    routerLink: ['/belepes'],
                    label: 'Belépés',
                    cssClass: 'btn btn-sm btn-outline-secondary mr-lg-2 mb-2 mb-lg-0'
                },
                {
                    routerLink: ['/regisztracio'],
                    label: 'Regisztráció',
                    cssClass: 'btn btn-sm btn-outline-secondary'
                }
            ]
        };
    }
}

interface IMainMenu {
    menus?: IMenu[];
    openedSubmenu?: IMenu;
    openedSubSubmenu?: IMenu;
}

interface IMenu {
    cssClass?: string;
    items: IMenuItem[];
}

interface IMenuItem {
    action?: Function;
    cssClass?: string;
    icon?: string;
    id?: string;
    label: string;
    routerLink?: any[];
    actionLink?: string;
    submenu?: IMenu;
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/main-menu/main-menu.component.ts